import React, { useState } from "react";
import { KeyRound, LockKeyhole, ShieldCheck } from "lucide-react";
import "../../pages/PasswordChange.css";

const PasswordChangeContent = ({ embedded = false, onSuccess }) => {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (field) => (event) => {
    setErrorMessage("");
    setSuccessMessage("");
    setFormData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
      setErrorMessage("All password fields are required.");
      return;
    }

    if (formData.newPassword.length < 8) {
      setErrorMessage("New password must be at least 8 characters.");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setErrorMessage("New password and confirm password must match.");
      return;
    }

    setSuccessMessage("Password changed successfully.");
    setFormData({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    });

    if (onSuccess) {
      onSuccess();
    }
  };

  return (
    <section className={`password-change-card${embedded ? " embedded" : ""}`}>
      <div className="password-change-head">
        <h2>Change Password</h2>
        <p>Use a strong password with letters, numbers, and symbols.</p>
      </div>

      <form className="password-change-form" onSubmit={handleSubmit}>
        <label className="password-change-field">
          <span className="password-change-label">
            <KeyRound size={15} />
            Current Password
          </span>
          <input
            type="password"
            value={formData.currentPassword}
            onChange={handleChange("currentPassword")}
            placeholder="Enter current password"
          />
        </label>

        <label className="password-change-field">
          <span className="password-change-label">
            <LockKeyhole size={15} />
            New Password
          </span>
          <input
            type="password"
            value={formData.newPassword}
            onChange={handleChange("newPassword")}
            placeholder="Enter new password"
          />
        </label>

        <label className="password-change-field">
          <span className="password-change-label">
            <ShieldCheck size={15} />
            Confirm Password
          </span>
          <input
            type="password"
            value={formData.confirmPassword}
            onChange={handleChange("confirmPassword")}
            placeholder="Re-enter new password"
          />
        </label>

        {errorMessage && <p className="password-change-error">{errorMessage}</p>}
        {successMessage && <p className="password-change-success">{successMessage}</p>}

        <div className="password-change-actions">
          <button type="submit" className="password-change-submit">
            Update Password
          </button>
        </div>
      </form>
    </section>
  );
};

export default PasswordChangeContent;
